import { BackendModel } from "../../core/backend.service";

export class ProductoVariante extends BackendModel {

    stock:String;
    color:String;
    talle:String;
    sku:String;

}


// WEBPACK FOOTER //
// ./src/app/productos/producto-details/producto-variante.ts